import { FirebaseError } from "firebase/app";
import { signInWithEmailAndPassword } from "firebase/auth";
import { Fragment, useState } from "react";
import { BrandLockup } from "./BrandLockup";
import { auth } from "../data/firebase";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string>();

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (e) {
      setError((e as FirebaseError).code.split("/")[1]);
    }
  };
  return (
    <Fragment>
      <div className="Login">
        <BrandLockup />
        <div className="Login-Container">
          <form className="Login-Form" onSubmit={onSubmit}>
            <input
              type="text"
              className="Login-Input text"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              className="Login-Input text"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" className="Login-Button text">
              Sign In
            </button>
            {error ? <div className="Login-Error">{error}</div> : null}
          </form>
        </div>
      </div>
    </Fragment>
  );
}
